/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Filter criteria for the execution forecast
 * @export
 * @interface ForecastFilterRequestDto
 */
export interface ForecastFilterRequestDto {
    /**
     * Forecast day as a working day offset from today. Currently only +1 is supported.
     * @type {number}
     * @memberof ForecastFilterRequestDto
     */
    forecastDayOffset?: number;
    /**
     * Active dunning procedures (rulesets) to include. Empty means all.
     * @type {Set<string>}
     * @memberof ForecastFilterRequestDto
     */
    rulesetIds?: Set<string>;
    /**
     * Dunning action types to include, e.g. Notification, ChangeOfLevel. Empty means all.
     * @type {Set<string>}
     * @memberof ForecastFilterRequestDto
     */
    actionTypes?: Set<string>;
    /**
     * Dunning level names the contract is forecast to change to. Empty means all.
     * @type {Set<string>}
     * @memberof ForecastFilterRequestDto
     */
    dunningLevelNames?: Set<string>;
}

/**
 * Check if a given object implements the ForecastFilterRequestDto interface.
 */
export function instanceOfForecastFilterRequestDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ForecastFilterRequestDtoFromJSON(json: any): ForecastFilterRequestDto {
    return ForecastFilterRequestDtoFromJSONTyped(json, false);
}

export function ForecastFilterRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForecastFilterRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'forecastDayOffset': !exists(json, 'forecastDayOffset') ? undefined : json['forecastDayOffset'],
        'rulesetIds': !exists(json, 'rulesetIds') ? undefined : json['rulesetIds'],
        'actionTypes': !exists(json, 'actionTypes') ? undefined : json['actionTypes'],
        'dunningLevelNames': !exists(json, 'dunningLevelNames') ? undefined : json['dunningLevelNames'],
    };
}

export function ForecastFilterRequestDtoToJSON(value?: ForecastFilterRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'forecastDayOffset': value.forecastDayOffset,
        'rulesetIds': value.rulesetIds === undefined ? undefined : Array.from(value.rulesetIds as Set<any>),
        'actionTypes': value.actionTypes === undefined ? undefined : Array.from(value.actionTypes as Set<any>),
        'dunningLevelNames': value.dunningLevelNames === undefined ? undefined : Array.from(value.dunningLevelNames as Set<any>),
    };
}

